export default __webpack_public_path__ + "static/media/earphones-grey.9f8863c6.svg";